// extracted by mini-css-extract-plugin
module.exports = {"container":"SideTabs_container__uB3Ux","icon":"SideTabs_icon__n2XMJ"};